<template>
    <div class="sendNoticeVue">
    <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <!-- <div class="col-md-6">
                    <h1 class="h1">Add Employer:</h1>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="o-filter-area">
                        <li><a @click="submitNewEmployer()" class="c-common-btn c-common-btn--large c-common-btn--green">  <i class="fa fa-plus" aria-hidden="true"></i>Submit new employer </a></li>
                    </ul>
                </div> -->
                <div class="col-sm-12">
                    <div class="text-center">
                        <ul class="o-filter-area notic-ul-item">
                            <li class="notic-li-item">
                                <span class="req-text">* </span>
                                <span>
                                    Employer accounts are managed by Call Steward, although as a client, you control the access that employer is granted.
                                </span>
                            </li>
                            <br />
                            <li class="notic-li-item">
                                <span class="req-text">* </span>
                                <span>
                                    Before you add an employer to your own list, please do a search to avoid duplicate entries.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="row c-responsive-fixwidth"  v-if="!step3">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Check Employer</h1>
                </div>
            </div>
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth" v-loading="loading">
            <div class="col-md-6 col-md-offset-3">
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white" v-if="!step3">
                    <div v-loading="loading" class="row">
                        <div class="col-sm-12"> 
                        
                            <!-- Unified search: debounced typing drives both the
                                 per-client lookup (top panel) and the global
                                 lookup (bottom panel) in parallel. No step
                                 advance button — both panels always mirror
                                 whatever's in the input. -->
                            <div class="form-group">
                                <br />
                                <br />
                                <label class="common-label-text o-super-label">Search Employer:</label>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <input type="search" class="form-control" v-model="internalEmployerSearch" id="employer-search-input" name="employer-search-cs3" placeholder="Name, email, phone, or location" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" @input="onSearchInput()" />
                                    </div>
                                </div>
                            </div>

                            <!-- Panel 1: already associated with this client -->
                            <div class="form-group" v-if="internalEmployerSearch.length">
                                <div v-if="employersList && employersList.length">
                                    <strong>Already on your list</strong>
                                    <br /><br />
                                    <table class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                                        <thead>
                                            <tr>
                                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">S.No:</span></th>
                                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Name:</span></th>
                                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Email</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(employerObj, index) in employersList" :key="index">
                                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5"><p>{{ index+1 }}</p></td>
                                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5"><p>{{ employerObj.employer.name }}</p></td>
                                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5"><p>{{ employerObj.employer.email }}</p></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else style="color: #666; font-style: italic;">
                                    Not currently assigned to this client — showing global matches below.
                                </div>
                            </div>

                            <!-- Panel 2: global pool, scoped outside this client's existing list -->
                            <div class="o-ndividualArea" v-if="internalEmployerSearch.length">
                                <div class="o-super-client-area c-radius3 u-bg-white">
                                    <strong>Available to add</strong>
                                    <br /><br />
                                    <div v-loading="loading" class="custom-list-search-background">
                                        <div v-for="(employer, inx) in filteredOptions" class="row custom-list-search" :key="inx">
                                            <div class="col-sm-9">
                                                <div><strong>{{employer.name}}</strong></div>
                                                <div v-if="employer.employer_users && employer.employer_users.length" class="employer-detail-section">
                                                    <span class="employer-detail-label">Contacts:</span>
                                                    <div v-for="(eu, euIdx) in employer.employer_users" :key="'eu-'+euIdx" class="employer-detail-item">
                                                        <span v-if="eu.user">{{eu.user.first_name}}</span>
                                                        <span v-if="eu.user && eu.user.email" class="employer-detail-muted"> - {{eu.user.email}}</span>
                                                    </div>
                                                </div>
                                                <div v-if="employer.phones && employer.phones.length" class="employer-detail-section">
                                                    <span class="employer-detail-label">Phones:</span>
                                                    <span v-for="(phone, phIdx) in employer.phones" :key="'ph-'+phIdx" class="employer-detail-item">
                                                        {{phone.number}}<span v-if="phIdx < employer.phones.length - 1">, </span>
                                                    </span>
                                                </div>
                                                <div v-if="employer.clientemployer && employer.clientemployer.length" class="employer-detail-section">
                                                    <span class="employer-detail-label">Locals:</span>
                                                    <span v-for="(ce, ceIdx) in employer.clientemployer" :key="'ce-'+ceIdx" class="employer-detail-item">
                                                        <span v-if="ce.client">{{ce.client.subdomain}}</span><span v-if="ceIdx < employer.clientemployer.length - 1">, </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-sm-3" style="text-align: right;">
                                                <a href="javascript: void(0)" @click="addIndividualExternalEmployer(employer)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i>Add</a>
                                            </div>
                                        </div>
                                        <div v-if="filteredOptions.length==0" class="row">
                                            <div class="col-sm-12" style="text-align: center;">
                                                <div>No global matches for this search</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Single button row: Cancel + Create New -->
                            <div class="text-center" style="margin-top: 20px;">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="cancelAddEmployerProcess()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" @click="openStep3()" class="c-solid-btn c-solid-btn--large c-solid-btn--orange"><i class="fa fa-plus" aria-hidden="true"></i> My Employer is Not Listed — Create New Employer</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="step3">
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-12">
                            <h1 class="h1 text-center">Add New Employer</h1>
                        </div>
                    </div>
                    <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                        <div class="field-group">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="c-common-space c-responsive-fixwidth c-radius3 c-user-tab-content clearfix o-skillset-area">
                                    <div class="col-sm-12 no_padding">
                                        <p>Basic Info:</p>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">Company Name:<sup>*</sup></label>
                                                    <input v-model="employer.company_name" @blur="blur($event)" v-validate="'required'" name="company name" type="text" class="form-control" placeholder="Name">
                                                    <span class="err-msg">**REQUIRED FIELD**</span>
                                                </div>
                                            </div>
                                        </div>
                                        <p>Admin User (Free):</p>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">Contact Person Name:<sup>*</sup></label>
                                                    <input v-model="employer.name" v-validate="'required'" @blur="blur($event)" name="Contact Person" type="text" class="form-control" placeholder="Name">
                                                    <span class="err-msg">**REQUIRED FIELD**</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="common-label-text form-label">Contact Email:<sup>*</sup></label>
                                                    <input v-on:keyup="emailExists()" v-model="employer.email" v-validate="'required|email'" @blur="blur($event)" name="email" type="text" class="form-control" placeholder="Email">
                                                    <span class="err-msg" v-if="!emailStatus && !(errors.has('email'))">Email already exists.</span>
                                                    <span v-if="!errors.has('email') && emailStatus" class="err-msg">**REQUIRED FIELD**</span>
                                                    <span v-else class="err-msg">{{ errors.first('email') }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="common-label-text form-label">Contact Phone:<sup>*</sup></label>

                                                    <input v-model="employer.primary_phone" v-validate="'required|min:10|max:15'" @blur="blurCellPhone($event)" type="tel" class="form-control" placeholder="Contact Phone" name="cellPhone" data-vv-delay="500">
                                                    <span v-if="errors.has('cellPhone')" class="err-msg">Contact Phone is required, Must have minimum length of 10</span>
                                                    <span v-else class="err-msg">**REQUIRED FIELD**  10 - 15 digits- Exclude all Dots, Spaces and Dashes. </span>
                                                </div>
                                            </div>
                                        </div>

                                        <br />
                                        <br />

                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="text-center">
                                                    <ul class="o-filter-area">
                                                        <li>
                                                            <a href="javascript: void(0)" @click="cancelAddEmployerProcess()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript: void(0)" @click="saveNewEmployer()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save" aria-hidden="true"></i> Save</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {bus} from '../../main';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../services.js';
    let timeout = null;

    export default {
        data() {
            return {
                addEmployerList:[],
                filteredOptions: [],
                selectedEmployerId:[],
                selectedEmployerPattern: '',
                loading:true,
                employerExistEmail:'',

                employersList: [],                
                internalEmployerSearch: '',
                step1: true,
                checkEmployerList: false,
                step2: false,
                step3: false,
                validation_err: 0,
                emailStatus:1,
                email_ckeck_flag: false,
                email_error_message: '',
                emailStatusMessage: '',
                employer:{
            		company_name:'',
            		company_email:'',
            		image:'',

            		name:'',
            		nick_name:'',
            		email:'',
            		primary_phone:'',
            		password: 'demo1234',
            		confirmPassword: 'demo1234',

        			company_address:'',
        			company_country:'',
        			company_municipality:'',
        			company_postcode:'',
        			company_state_province:'',

        			company_primary_phone:'',
        			company_secondary_phone:'',
        			company_cell_phone:'',
        			company_fax:'',
                    client_id: ''      	
            	},
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        // watch: {
        //     addEmployerList: {
        //         handler(newAllOptions) {
        //             this.filteredOptions = [...newAllOptions]
        //         },
        //         immediate: true
        //     }
        // },
        methods: {
            async checkMailWithMailgun(email) {
                if(this.validateEmail(email)) {
                    await service.get('employee/validateEmail/'+email, {
                        'Authorization': this.userToken,
                    }).
                    then((res) => {
                        if(res.data.result == 'undeliverable'){
                            this.mailGunError = res.data.reason[0];
                            this.mailGunResult = false;
                        }else{
                            this.mailGunResult = true;
                        }                
                    }).catch((err) => {
                        console.log(err);
                    });
                }else {
                    this.mailGunResult = false;
                }
            },
            // Debounced input handler — one timer per keystroke, 250ms after
            // typing stops we fire both the per-client lookup and the global
            // search in parallel. Keeps both panels synced without dueling
            // queries on fast typing.
            onSearchInput() {
                if (this._searchDebounce) clearTimeout(this._searchDebounce);
                this._searchDebounce = setTimeout(() => {
                    this._searchDebounce = null;
                    this.runBothSearches();
                }, 250);
            },

            async runBothSearches() {
                const q = this.internalEmployerSearch;
                if (!q || !q.length) {
                    this.employersList = [];
                    this.filteredOptions = [];
                    return;
                }
                // Keep selectedEmployerPattern in sync so downstream helpers
                // (searchExternalEmployers, email pre-fill on Create) still work.
                this.selectedEmployerPattern = q;
                await Promise.all([
                    this.getAllClientEmployers(),
                    this.filterOptions(q),
                ]);
            },

            async openStep3() {
                // Advance to Step 3 — user will complete the form there.
                // If the search term is a valid email AND Mailgun accepts it, pre-fill.
                // Otherwise just open a blank email field; final validation happens on save.
                const q = this.internalEmployerSearch || this.selectedEmployerPattern;
                if (q && this.validateEmail(q)) {
                    this.loading = true;
                    await this.checkMailWithMailgun(q);
                    this.loading = false;
                    if (this.mailGunResult) {
                        this.employer.email = q;
                    }
                }
                this.step3 = true;
                this.step2 = false;
                this.step1 = false;
            },

            async filterOptions(filterValue) {
                console.log(filterValue);
                await this.searchExternalEmployers();
                this.filteredOptions = this.addEmployerList.filter(
                    option => {
                        if(option.name && option.name.toLowerCase().includes(filterValue.toLowerCase())) return true;
                        if(option.email && option.email.toLowerCase().includes(filterValue.toLowerCase())) return true;
                        if(option.employer_users && option.employer_users.length) {
                            for(let eu of option.employer_users) {
                                if(eu.user && eu.user.email && eu.user.email.toLowerCase().includes(filterValue.toLowerCase())) return true;
                                if(eu.user && eu.user.first_name && eu.user.first_name.toLowerCase().includes(filterValue.toLowerCase())) return true;
                            }
                        }
                        return false;
                    }
                )
            },

            cancelAddEmployerProcess() {
                this.internalEmployerSearch = '';
                this.employersList = [];
                this.checkEmployerList= false;
                this.step1 = true;
                this.step2=false;
                this.step3=false;
            },

            async addExternalEmployer() {
                this.selectedEmployerPattern = this.internalEmployerSearch;
                await this.filterOptions(this.selectedEmployerPattern);
                this.checkEmployerList= false;
                this.step1 = false;
                this.step2 = true;
            },

            async searchExternalEmployers() {
                this.loading = true;
                await service.get('employer/searchEmployers', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'search': this.selectedEmployerPattern
                }).
                then((res) => {
                    console.log(res.data);
                    this.addEmployerList = res.data.result;
                    this.loading=false;
                }).catch((err) => {
                    this.loading=false;
                });
            },

            async getAllClientEmployers() {
                this.$Progress.start();
                await service.get('employer/clientEmployerListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'search': this.internalEmployerSearch,
                }).
                then((res) => {
                    this.employersList = res.data.result;
                    this.$Progress.finish();
                    this.loading=false;
                    // if(res.data.result.data.length == 0 && this.internalEmployerSearch.length && this.internalEmployerSearch.length % 3 == 0) {
                    //     this.$notify.info({
                    //         message: "No Employers found in the search",
                    //         title: "No Employers Found!"
                    //     })
                    // }
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                });
                // this.step1 = false;
                this.checkEmployerList = true;
            },

            checkEmail(){
                service.get('user/emailExists', {
                    'Authorization': this.userToken,
                    'email':this.employerExistEmail,
                }).
                then((res) => {
                //    console.log("Email Status", res.data.result);
                   if(res.data.result==0){
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Email already exist as an Employer! Please Add',
                            type: 'error'
                        });
                   }else{
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Your email address is not registered. Please register.',
                            type: 'success'
                        });
                   }
                   
                }).catch((err) => {
                    console.log(err);
                });
            },

            addIndividualExternalEmployer(employer) {
                console.log(employer);
                if((this.selectedEmployerPattern != '')){
                    this.selectedEmployerId.push(employer.id);
                    this.loading=true;
                    service.post('employer/clientEmployerAssociation', 
                    {
                        'employerIds':JSON.stringify(this.selectedEmployerId),
                    },
                    {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Employer added Successfully.',
                            type: 'success'
                        });
                        this.loading=false;
                        this.selectedEmployerPattern = '';
                        this.selectedEmployerId = [];
                        this.$router.go(-1);
                    }).catch((err) => {
                        this.loading=false;
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Sorry! something went wrong.',
                            type: 'error'
                        });
                    });
                }else{
                    this.$notify({
                        title: "Select Employer!",
                        message: 'Please select employer.',
                        type: 'error'
                    });
                }
            },

            // addEmployer(){
            //     this.selectedEmployerId = [];
            //     let idx = this.addEmployerList.findIndex((obj) => obj.id == this.selectedEmployerPattern);
            //     let addStatus = false;
            //     if(idx >= 0) {
            //         addStatus = true;
            //     }

            //     if((this.selectedEmployerPattern != '') && (this.selectedEmployerPattern != this.internalEmployerSearch) && addStatus){
            //         this.selectedEmployerId.push(this.selectedEmployerPattern);
            //         this.loading=true;
            //         service.post('employer/clientEmployerAssociation', 
            //         {
            //             'employerIds':JSON.stringify(this.selectedEmployerId),
            //         },
            //         {
            //             'Authorization': this.userToken,
            //             'cs3-context-role': this.userRole,
            //             'cs3-context-clientId': this.userClientID
            //         }).
            //         then((res) => {
            //             this.$notify({
            //                 title: this.$t('success'),
            //                 message: 'Employer added Successfully.',
            //                 type: 'success'
            //             });
            //             this.loading=false;
            //             this.selectedEmployerPattern = '';
            //             this.selectedEmployerId = [];
            //             this.$router.go(-1);
            //         }).catch((err) => {
            //             this.loading=false;
            //             this.$notify({
            //                 title: this.$t('error'),
            //                 message: 'Sorry! something went wrong.',
            //                 type: 'error'
            //             });
            //         });
            //     }else{
            //         this.$notify({
            //             title: "Select Employer!",
            //             message: 'Please select employer.',
            //             type: 'error'
            //         });
            //     }
            // },

            submitNewEmployer(){
                this.$router.push({
                    path: "/addEmployerClient"
                });
            },

            checkClientEmployerList() {
                if(this.internalEmployerSearch.length){
                    this.getAllClientEmployers();
                    // console.log(this.internalEmployerSearch);
                }else{
                    this.employersList = [];
                }
            },
            async checkClientEmployerListOnClick() {
                this.loading = true;
                await this.getAllClientEmployers();
                this.loading = false;

                const isEmail = this.validateEmail(this.internalEmployerSearch);
                if(isEmail && this.employersList.length){
                    this.$notify.error({
                        message: "Email already exists and is associated to your account",
                        title: "Employer Exists!"
                    });
                }else if(isEmail && !this.employersList.length) {
                    this.selectedEmployerPattern = this.internalEmployerSearch;
                    this.addExternalEmployer();
                }
                // Non-email searches (name, phone) stay on the local results list —
                // no error, no forced external flow. User can click "+ Add External
                // Employer" to broaden to the global search if needed.

                // if(this.internalEmployerSearch.length){
                //     this.getAllClientEmployers();
                //     // console.log(this.internalEmployerSearch);
                // }else{
                //     this.employersList = [];
                // }
            },

            validateEmail(input) {
                var validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (input.match(validRegex)) {
                    return true;
                } else {
                    this.emailStatus=false;
                    this.emailStatusMessage='';
                    return false;
                }
            },
            
            async saveNewEmployer(){
                await this.emailExists();
                // this.checkCellPhone(this.employer.primary_phone);
                this.employer.client_id = this.userClientID;
                var cell_phone = '';
                if(this.employer.primary_phone=='' || this.employer.primary_phone=="") {
                    this.$notify.error({
                        message: 'Phone number is Missing. Please add cell phone',
                        title: 'Check Required Fields!'
                    })
                    this.employer.primary_phone = '';
                    return;
                }
                if(!this.emailStatus) {
                    this.$notify.error({
                        message: this.email_error_message,
                        title: 'Email Already Registered!'
                    })
                    return;
                }else if(!this.validation_err) {
                    this.$notify.error({
                        message: 'Please check required fields and phone number format',
                        title: 'Check Required Fields!'
                    })
                    return;
                }
        		this.loading=true;
                
				await service.post('employer', this.employer, {
                    'Authorization': this.userToken
                }).
                then((res) => {
					this.loading=false;
					// console.log(res.data.status_code);
					if(res.data.status_code&&res.data.status_code!="0"){
						this.$message({
							type: 'success',
                            title: 'Success',
							message: 'Employer added successfully.'
						});
						this.$router.go(-1);
					}else if(res.data.status_code&&res.data.status_code=="0") {
                        this.$message({
							type: 'error',
                            title: 'Error',
							message: res.data.status_message[0]
						});
                    }else{
						this.$message({
							type: 'error',
							message: 'Sorry, Something Went Wrong: Please try again later.'
						});
					}
                    // this.$router.push({
                    //     path: `/clientEmployersList`
                    // });
                    //console.log(res);
                }).catch((err) => {
                    this.loading=false;
                    this.$message({
                        type: 'error',
                        message: 'Sorry, Something Went Wrong: Please try again later.'
                    });
                }); 	
        	},

            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 0;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 1;
                }
            },

            blurCellPhone(event){
                let phone=$(event.target).val();
                let patt=/^\d{10,12}$/g;
                if(patt.test(phone) && phone != ""){
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }else{
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 1;
                    else
                        this.validation_err = 0;
                });
            },

            checkCellPhone(phone){
                let pat=/^\d{10,12}$/g;
                if(pat.test(phone) && phone != ""){
                    this.validation_err = 0;
                }else{
                    this.validation_err = 1;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 1;
                    else
                        this.validation_err = 0;
                });
            },
            
            async emailExists(){
                this.email_error_message = '';
                this.email_ckeck_flag=true;
                clearTimeout(timeout);
                // timeout = setTimeout(() => {
                    await service.get('user/emailExists', {
                        'Authorization': this.userToken,
                        'email':this.employer.email,
                    }).
                    then((res) => {
                        this.email_ckeck_flag=false;
                        // console.log("Email Status", res.data.result);
                        this.emailStatus=res.data.result;
                        this.email_error_message = res.data.status_message
                        console.log(this.emailStatus);
                        // return res.data.result
                    }).catch((err) => {
                        this.email_ckeck_flag=false;
                        console.log(err);
                        // return 0;
                    });
                // }, 1000);
            },
        },
        mounted() {
            document.getElementById('employer-search-input').focus();
        },
        created() {
            this.loading=false;
            
            // this.getAllClientEmployers();
        }
    }

</script>
<style scoped>

.email-status-success {
    color: #06aa00;
    font-weight: bold;
    padding: 0;
    height: 20px;
}
.email-status-error {
    color: #dd3000;
    font-weight: bold;
    padding: 0;
    height: 20px;
}
.pl-20{
    padding-left: 20px;
}
.pb-6{
    padding-bottom: 6px;
}
.custom-list-search-background {
    background-color: #f4f7f8;
    padding: 5px;
    border-radius: 6px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
}

.custom-list-search{
    margin: 5px;
    padding: 5px;
    border-bottom: 1px solid #afacac;
    word-break: break-all;
}
.el-select-dropdown__item{
    padding-right: 40px;
}
.mt-15 {
    margin-top: 15px;
}
.el-input__inner {
    /* display: none; */
    height: auto !important
}
.line-break-between-section{
    margin-top: 50px;
}
.notic-ul-item{
    border-radius: 6px;
    background-color: #e4d8d8;
    padding: 10px;
}
.notic-li-item{
    padding: 5px;
}

.notic-ul-item{
    border-radius: 6px;
    background-color: #e4d8d8;
    padding: 10px;
}
.notic-li-item{
    padding: 5px;
}
.employer-detail-section {
    margin-top: 3px;
    font-size: 12px;
}
.employer-detail-label {
    color: #8492a6;
    font-weight: bold;
    margin-right: 4px;
}
.employer-detail-item {
    color: #555;
}
.employer-detail-muted {
    color: #8492a6;
    font-size: 12px;
}
</style>
